import orders from "./orders";
import auth from "./auth";
import menu from "./menu";
import cart from "./cart";
import app from "./app";

const APIs = { app, cart, menu, orders, auth };

export default APIs;
